export const Btn = ({ children, onClick, size = "md", style = {}, disabled = false, className = "" }) => {
  const base = {
    border: "none", borderRadius: "7px", fontWeight: 500,
    cursor: disabled ? "not-allowed" : "pointer", transition: "all .15s",
    display: "inline-flex", alignItems: "center", gap: 6,
    padding: size === "sm" ? "6px 12px" : size === "xs" ? "4px 8px" : "10px 20px",
    fontSize: size === "sm" ? 13 : size === "xs" ? 12 : 14, opacity: disabled ? .45 : 1,
  };
  return <button onClick={disabled ? undefined : onClick} style={{ ...base, ...style }} className={className}>{children}</button>;
};

export const Field = ({ label, children, error, G }) => (
  <div style={{ marginBottom: 14 }}>
    {label && (
      <label style={G ? { color: G.ink2 } : undefined}>
        {label}
      </label>
    )}
    {children}
    {error && <div style={{ fontSize: 11, color: "#C53030", marginTop: 3 }}>{error}</div>}
  </div>
);

export const Card = ({ children, style = {}, G }) => (
  <div style={{ background: G.surface, border: `1px solid ${G.border}`, borderRadius: 10, padding: 20, boxShadow: G.shadow, ...style }}>
    {children}
  </div>
);

export const SectionTitle = ({ children, G }) => (
  <h2 style={{ fontFamily: "'Lora', serif", fontSize: 20, fontWeight: 600, marginBottom: 18, color: G.ink }}>{children}</h2>
);

export const Toggle = ({ label, value, onChange, G }) => (
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", gap: 8, borderBottom: `1px solid ${G.border}` }}>
    <span style={{ fontSize: 14, color: G.ink }}>{label}</span>
    <div onClick={() => onChange(!value)} style={{ width: 42, height: 24, borderRadius: 12, background: value ? G.accent : G.border, position: "relative", cursor: "pointer", transition: "background .2s" }}>
      <div style={{ position: "absolute", top: 3, left: value ? 21 : 3, width: 18, height: 18, borderRadius: "50%", background: "#fff", transition: "left .2s", boxShadow: "0 1px 3px rgba(0,0,0,.2)" }} />
    </div>
  </div>
);